import styled from "styled-components";

export const InvestmentColumn = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    text-transform: none;
    font-size: 11px;
    font-weight: normal;
`;

export const InvestmentCell = styled(InvestmentColumn)`
    font-size: 12px;
    align-items: flex-end;
`;